import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import  LeadListLayer  from '../components/leads/LeadListLayer'

export const LeadListPage = () => {
  return (
    <MasterLayout>
        <LeadListLayer/>
    </MasterLayout>
  )
}
